import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { decorateIntlMessages } from '../common/rosetta_formatted_message';
import SearchForm from '../search/search_form';
import { sendDataLayerEvent } from '../../utils/analytics';

const i18nMessages = decorateIntlMessages(__filename, defineMessages({
  'placeholder': {
    id: 'placeholder',
    description: 'Placeholder text for the search box in the header.',
    defaultMessage: 'Search'
  },
  close_button_title: {
    id: 'close_button_title',
    description: 'Close button title attribute content (Close)',
    defaultMessage: 'Close'
  }
}));

export class SearchNav extends Component {

  handleSubmit = (_, query) => {
    sendDataLayerEvent('nav_item_click', {data: {navLocation: 'header', navItem: `search '${query}'`}});
  };

  render = () => (
    <div tabIndex="0" className="global-search-nav" aria-label="global search"
    >
      <div className="search-drawer" tabIndex="0">
        <SearchForm id="search-header"
          handleSubmit={this.handleSubmit}
          placeholderMessage={i18nMessages.placeholder}
          recordSearchTerm={this.props.recordSearchTerm}
        />
      </div>
    </div>
  );
}

export default injectIntl(SearchNav);

SearchNav.propTypes = {
  recordSearchTerm: PropTypes.func.isRequired
};
